<script setup>
import { computed, ref, getCurrentInstance, onMounted, onUnmounted } from 'vue'
import TabGroup from '../../Atoms/TabGroup.vue';
import TabItem from '../../Atoms/TabItem.vue';
import CirclePing from '../../Atoms/CirclePing.vue';

const props = defineProps({
  stream: {
    type: Object,
    required: true,
    validator(v) {
      return Object.prototype.hasOwnProperty.call(v, '_id');
    }
  },
  streamAlive: {
    type: Boolean
  },
  selectedPreviewTab: {
    type: String
  },
  playbackClicked: {
    type: Boolean,
    default: false,
  },
  transcoderView: {
    type: Boolean,
    default: false
  },
})

const emit = defineEmits(['show-stream-toggle-modal'])

const onSelectTab = (tabName) => emit('select-option-tab', tabName)

const tabItemClass = (isActive) => `text-tiny md:text-base font-medium h-10 py-2 border-b-2 text-surface-9 hover:no-underline text-nowrap leading-none flex items-center w-full capitalize mx-auto -mb-px justify-center relative ${isActive && !props.transcoderView ? 'text-white border-main' : 'border-transparent'} ${!props.transcoderView ? 'hover:border-white hover:text-white' : ''}`

</script>
<template>
  <!-- Transcoder is a single-purpose ingest panel; no tab bar needed. -->
  <!-- Keep all three tabs visible (no horizontal scroll): flex-1 shares width; override TabGroup shrink-0/overflow. -->
  <TabGroup v-if="!transcoderView" type="lines" class="w-full !rounded-none bg-surface-4 !overflow-x-hidden [&>*]:!shrink">
    <TabItem class="flex-1 min-w-0" :customClasses="tabItemClass(selectedPreviewTab === 'source-setup')"
      @click="onSelectTab('source-setup')" :isActive="selectedPreviewTab === 'source-setup'">Source Setup</TabItem>
    <TabItem class="flex-1 min-w-0" :customClasses="tabItemClass(selectedPreviewTab === 'playback')"
      @click="onSelectTab('playback')" :isActive="selectedPreviewTab === 'playback'">
      Playback
      <CirclePing class="!absolute right-3"
        v-if="streamAlive && stream.enabled && (selectedPreviewTab != 'playback') && !playbackClicked" />
    </TabItem>
    <TabItem class="flex-1 min-w-0" :customClasses="tabItemClass(selectedPreviewTab === 'monitoring')"
      @click="onSelectTab('monitoring')" :isActive="selectedPreviewTab === 'monitoring'">Monitoring</TabItem>
  </TabGroup>
</template>